import { useEffect, useState } from 'react';
import ApiError from '../models/api-error';
import config from '../components/megawidget/widget-config';

class ApiFacade {
    private authToken: string

    constructor(authToken: string) {
        this.authToken = authToken;
    }

    static constructHeaders() {
        const headers = new Headers();
        // headers.set('Authorization', token);
        headers.set('Access-Control-Allow-Origin', '*');
        headers.set('Content-Type', 'application/json; charset=utf-8');
        headers.set('Accept', '*/*');
        headers.set('Accept-Encoding', 'gzip, deflate, br');
        headers.set('Connection', 'keep-alive');
        return headers;
    }

    static handleResponse(response: Response) {
        if (response.ok) {
            return response.json();
        }
        // else {
        //     const apiError = new ApiError(response.status.toString(), new Error().stack);
        //     ApiFacade.post(config.ENDPOINT_FOR_ERRORS, apiError, null);
        // }
    }

    static get(url, options) : any {
        return fetch(url, {
            headers: this.constructHeaders(),
            ...options,
        })
             .then(this.handleResponse)
    }

    static post(url, body, options) {
        return fetch(url, {
            method: 'POST',
            mode:'cors',
            headers: this.constructHeaders(),
            body: JSON.stringify(body),
            ...options,
        })
        .then(this.handleResponse)
    }
}

export default ApiFacade;